import { Outlet, useLocation } from 'react-router-dom';

const GlobalLayout = () => {
    const location = useLocation();
    const isDashboard = location.pathname.startsWith('/dashboard');

    return (
        <div className={`min-h-screen relative overflow-hidden font-sans ${isDashboard ? 'bg-transparent text-white' : 'bg-cloud-100 text-cloud-950'}`}>
            {/* Background accents - only for non-dashboard pages */}
            {!isDashboard && (
                <div
                    className="fixed inset-0 pointer-events-none"
                    style={{
                        background: 'radial-gradient(circle at top right, rgba(255, 255, 255, 0.4) 0%, transparent 40%), radial-gradient(circle at bottom left, rgba(245, 192, 67, 0.1) 0%, transparent 30%)',
                        zIndex: 0
                    }}
                ></div>
            )}

            {/* CONTENT SLOT */}
            <div className="relative z-10 w-full min-h-screen">
                <Outlet />
            </div>
        </div>
    );
};

export default GlobalLayout;
